import {styled} from '@mui/system';

export const MuiButtonIcon = styled('div')({
	display: 'flex',
	flexGrow: 1,
	justifyContent: 'center',
	alignItems: 'center',
});
